export enum OrganizationSubscriptionsTableAccessors {
  Name = 'name',
  SubscriptionPlan = 'subscription-plan',
  Price = 'price',
}
